import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { bindActionCreators } from 'redux';
import AvailabilityDetailActions from '../actions/AvailabilityDetailActions';
import StackMapActions from '../actions/StackMapActions';
import AvailabilityDetailOverlay from '../components/shared/AvailabilityDetailOverlay';
import availabilityShape from '@bibliocommons/bc-prop-types';
import { currentLibrarySelector } from '../selectors/LibrarySelector';

function mapStateToProps(state, ownProps) {
  const availabilityDetail = state.get('availabilityDetail');
  const library = currentLibrarySelector(state);
  const checkILSErrorClassification = availabilityDetail.get('errorClassification');

  return {
    items: availabilityDetail.get('items'),
    subscriptions: availabilityDetail.get('subscriptions'),
    marcHoldings: availabilityDetail.get('marcHoldings'),
    isFetching: availabilityDetail.get('isFetching'),
    stackMapSettings: library.get('stackMap'),
    bib: state.getIn(['entities', 'bibs', ownProps.params.metadataId], Immutable.Map()),
    stackMapOpen: state.getIn(['ui', 'stackmap', 'open']),
    standalone: ownProps.router.location.pathname === `/v2/availability/${ownProps.params.metadataId}`,
    showDueDateInCirc: library.get('showDueDateInCirc'),
    showCollectionInCirc: library.get('showCollectionInCirc'),
    isILSDown: typeof checkILSErrorClassification !== 'undefined' && checkILSErrorClassification.length > 0
  };
}

function mapDispatchToProps(dispatch) {
  return {
    availabilityDetailActions: bindActionCreators(AvailabilityDetailActions, dispatch),
    ...bindActionCreators(StackMapActions, dispatch)
  };
}

class AvailabilityDetailsContainer extends React.Component {
  static fetchInitialData(params, query, store) {
    return [
      store.dispatch(AvailabilityDetailActions.getAvailability(params.metadataId))
    ];
  }

  constructor(props) {
    super(props);
    this.state = {
      open: false
    };
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    setTimeout(() => this.setState({ open: true }), 0);
  }

  handleClose() {
    this.setState({
      open: false
    });
    setTimeout(() => {
      browserHistory.goBack();
    }, 300);
  }

  render() {
    const { subscriptions,
      marcHoldings,
      items,
      bib,
      availabilityDetailActions,
      isILSDown
    } = this.props;
    return (
      <AvailabilityDetailOverlay
        bib={bib}
        availabilityDetailActions={availabilityDetailActions}
        availabilityDetail={{ subscriptions,
          marcHoldings,
          items }}
        open={this.state.open}
        disableClose={this.props.stackMapOpen || this.props.standalone}
        handleClose={this.handleClose}
        isFetching={this.props.isFetching}
        openStackMap={this.props.openStackMap}
        stackMap={this.props.stackMapSettings}
        standalone={this.props.standalone}
        showDueDateInCirc={this.props.showDueDateInCirc}
        showCollectionInCirc={this.props.showCollectionInCirc}
        isILSDown={isILSDown} />
    );
  }
}

AvailabilityDetailsContainer.propTypes = {
  bib: ImmutablePropTypes.map.isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func.isRequired),
  subscriptions: ImmutablePropTypes.list,
  items: ImmutablePropTypes.listOf(ImmutablePropTypes.contains({
    label: PropTypes.string,
    items: ImmutablePropTypes.listOf(
      ImmutablePropTypes.contains({
        availability: availabilityShape,
        branch: ImmutablePropTypes.contains({
          code: PropTypes.string,
          name: PropTypes.string
        }),
        branchName: PropTypes.string,
        callNumber: PropTypes.string,
        collection: PropTypes.string,
        copy: PropTypes.string,
        dueDate: PropTypes.number,
        groupName: PropTypes.string,
        local: PropTypes.bool,
        preferred: PropTypes.bool,
        volume: PropTypes.string
      })
    )
  })),
  stackMapOpen: PropTypes.bool,
  stackMapSettings: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool,
    branches: ImmutablePropTypes.listOf(PropTypes.string),
    domain: PropTypes.string
  }),
  marcHoldings: ImmutablePropTypes.list,
  isFetching: PropTypes.bool,
  openStackMap: PropTypes.func,
  standalone: PropTypes.bool,
  showDueDateInCirc: PropTypes.bool,
  showCollectionInCirc: PropTypes.bool,
  isILSDown: PropTypes.bool
};

export default connect(mapStateToProps, mapDispatchToProps)(AvailabilityDetailsContainer);



// WEBPACK FOOTER //
// ./app/containers/AvailabilityDetailsContainer.jsx